import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';
import { camelCaseTransformer } from '@sondermind/utilities/tools';

import { ISpecialty, ISpecialtyApiResponse } from '../models/specialty';

@Injectable({
  providedIn: 'root'
})
export class FilterOptionsHttpService {
  constructor(
    private configurationService: ConfigurationService,
    private http: HttpService,
  ) { }

  listSpecialties$(opts: Partial<IAPIListRequestOptions> = {}): Observable<IAPIListResponse<ISpecialty>> {
    const params = this.http.generateListParams(opts);
    return this.http
      .get<IAPIListResponse<ISpecialtyApiResponse>>(this.fetchUrlSpecialties, params)
      .pipe(
        map((response: IAPIListResponse<ISpecialtyApiResponse>) => (
          {
            ...response,
            data: response.data.map(
              (concernApiResponse: ISpecialtyApiResponse) => camelCaseTransformer<ISpecialty>(concernApiResponse)
            )
          }
        )),
        this.http.handleHttpErrorStrict()
      );
  }

  get fetchUrlSpecialties(): string {
    return `${this.configurationService.env.enginelessBase}/reference_datum/specialties`;
  }
}
